import coreStore from "./core-store";
import Vue from 'vue'
import Axios from 'axios'

const remoteResource = 'cashflow/api/v1/cash-flow-reports';

const store = coreStore.createCoreStore('cashflowReport', remoteResource);

store.state.reports = {};

store.getters.report = (state) => (id) => {
    return state.reports[id];
}

store.mutations.setReport = function(state, {report, reportId}) {
    Vue.set(state.reports, reportId, report);
}

store.actions.reloadReport = function({commit, dispatch}, {reportId}) {
    return Axios.get(`cashflow/api/v1/cash-flow-report-definitions/${reportId}/report`)
        .then(res => {
            commit("setReport", {reportId: reportId, report: res.data});
        });
}

store.actions.reloadReportTransient = function({commit, dispatch}, {reportDefinition}) {
    return Axios.post(`cashflow/api/v1/cash-flow-report-definitions/report`, reportDefinition)
        .then(res => {
            commit("setReport", {reportId: reportDefinition.id, report: res.data});
        });
}

export default store;
